import '../assets/NcAppSettingsShortcutsSection-BuI-s4kd.css';
import { defineComponent } from "vue";
import { N as NcAppSettingsSection } from "./NcAppSettingsSection-BjQllLEA.mjs";
import { r as register, x as t31, a as t } from "./_l10n-BcrsamRV.mjs";
import { n as normalizeComponent } from "./_plugin-vue2_normalizer-DU4iP6Vu.mjs";
register(t31);
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NcAppSettingsShortcutsSection",
  setup(__props) {
    return { __sfc: true, NcAppSettingsSection, t };
  }
});
const appSettingsSectionShortcuts = "_appSettingsSectionShortcuts_14egw_20";
const style0 = {
  "material-design-icon": "_material-design-icon_14egw_12",
  appSettingsSectionShortcuts
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c(_setup.NcAppSettingsSection, { attrs: { "id": "keyboard-shortcuts", "name": _setup.t("Keyboard shortcuts") } }, [_c("div", { class: _vm.$style.appSettingsSectionShortcuts }, [_vm._t("default")], 2)]);
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles,
  null
);
const NcAppSettingsShortcutsSection = __component__.exports;
export {
  NcAppSettingsShortcutsSection as N
};
//# sourceMappingURL=NcAppSettingsShortcutsSection-DzjowBeE.mjs.map
